import { Box, Text } from "@chakra-ui/react";

const StarsButton = ({text, pt, mt, ml, transform, onClick}) => {
  return (
    <Box 
      className="container-btn" 
      pt={pt} 
      mt={mt ?? 0} 
      ml={ml ?? 'unset'}
      display="flex"
      transform={ transform ?? 'scale(1)'}
      justifyContent="center" 
      alignItems="center">
      <Box className="button" position="relative" p="20px" cursor="pointer" onClick={onClick} >
        <Box className="line-container" position="relative" textAlign="center">
          <Text className="text" fontSize="24px" fontWeight="bold">{ text }</Text>
          <Box className="line line--top-left line--thick thick-line--short"></Box>
          <Box className="line line--top-right line--thick thick-line--short"></Box>
          <Box className="line line--bottom-left line--thick thick-line--long"></Box>
          <Box className="line line--bottom-right line--thick thick-line--long"></Box>
          <Box className="line line--top line--thin"></Box>
          <Box className="line line--bottom line--thin"></Box>
        </Box>
      </Box>
    </Box>
  );
};

export default StarsButton;
